import React from 'react';
import { FadeInSection } from './ui/FadeInSection';
import { CTAButton } from './ui/CTAButton';
import { Star, Diamond } from 'lucide-react';
export function SocialProofAndUpsell() {
  const testimonials = [{
    quote: 'En 21 días bajé 3 kilos sin privarme de nada. Sigo comiendo alfajores.',
    author: 'Mariana G., 34 | Buenos Aires'
  }, {
    quote: 'El helado de chocolate proteico lo hago todas las semanas. Mi familia no nota que es fit.',
    author: 'Carolina P., 41 | Córdoba'
  }, {
    quote: 'Entendí por qué me daba el pico de las 4pm. Ya no me da.',
    author: 'Valentina R., 29 | Rosario'
  }, {
    quote: 'El Kit 11:11 me salvó tres veces esta semana.',
    author: 'Florencia M., 47 | Mendoza'
  }, {
    quote: 'La chocotorta fit quedó igual que la original. Mi marido la pide todos los fines de semana.',
    author: 'Luciana B., 38 | La Plata'
  }];
  return <>
      {/* SECTION 13 — TESTIMONIALS */}
      <section className="bg-cream px-4 py-16 md:py-24" data-id="element-214">
        <div className="max-w-4xl mx-auto" data-id="element-215">
          <FadeInSection data-id="element-216">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-217">
              {testimonials.map((t, idx) => <div key={idx} className={`bg-white p-6 rounded-2xl shadow-sm border border-cream-dark flex flex-col ${idx === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-218">
                  <div className="flex gap-1 mb-4" data-id="element-219">
                    {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-gold text-gold" data-id="element-220" />)}
                  </div>
                  <p className="text-textBody font-medium italic mb-6 flex-grow" data-id="element-221">
                    "{t.quote}"
                  </p>
                  <p className="text-sm font-bold text-chocolate-light" data-id="element-222">
                    — {t.author}
                  </p>
                </div>)}
            </div>
          </FadeInSection>
        </div>
      </section>

      {/* SECTION 14 — UPSELL */}
      <section className="bg-chocolate px-4 py-16 md:py-24" data-id="element-223">
        <div className="max-w-3xl mx-auto" data-id="element-224">
          <FadeInSection data-id="element-225">
            <div className="bg-chocolate-light border-2 border-gold rounded-3xl p-6 md:p-10 relative shadow-gold" data-id="element-226">
              <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-gold text-chocolate px-6 py-2 rounded-full font-bold flex items-center gap-2 shadow-md whitespace-nowrap" data-id="element-227">
                <Diamond className="w-4 h-4 fill-chocolate" data-id="element-228" />
                PROTOCOLO DÍA BLINDADO
              </div>

              <div className="text-center mt-6 mb-8" data-id="element-229">
                <p className="text-gold-light font-bold tracking-widest text-sm mb-4" data-id="element-230">
                  UPGRADE EXCLUSIVO
                </p>
                <p className="text-xl md:text-2xl text-cream mb-2" data-id="element-231">
                  El Método resuelve tus antojos.
                </p>
                <p className="text-2xl md:text-3xl font-bold text-gold" data-id="element-232">
                  El Protocolo resuelve tu día completo.
                </p>
              </div>

              <ul className="space-y-4 mb-8 text-warmWhite max-w-lg mx-auto" data-id="element-233">
                <li className="flex items-start gap-3" data-id="element-234">
                  <span className="text-gold mt-1" data-id="element-235">→</span>
                  <span data-id="element-236">
                    Desayuno, almuerzo, merienda y cena alineados con el Método
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-237">
                  <span className="text-gold mt-1" data-id="element-238">→</span>
                  <span data-id="element-239">Plan de 21 días con menú diario</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-240">
                  <span className="text-gold mt-1" data-id="element-241">→</span>
                  <span data-id="element-242">El "Plato Blindado" para cada comida principal</span>
                </li>
              </ul>

              <div className="text-center mb-10" data-id="element-243">
                <p className="text-xl font-bold text-gold" data-id="element-244">
                  No es una dieta.
                  <br data-id="element-245" />
                  Es tu nuevo estilo de vida.
                </p>
              </div>

              <div className="bg-chocolate rounded-2xl overflow-hidden mb-8 border border-gold/20" data-id="element-246">
                <div className="grid grid-cols-2 text-center border-b border-gold/20" data-id="element-247">
                  <div className="p-4 text-cream font-bold border-r border-gold/20" data-id="element-248">
                    SISTEMA
                  </div>
                  <div className="p-4 bg-gold/10 text-gold font-bold flex items-center justify-center gap-2" data-id="element-249">
                    COMBO ⭐
                  </div>
                </div>
                <div className="grid grid-cols-2 text-center border-b border-gold/20" data-id="element-250">
                  <div className="p-4 text-cream border-r border-gold/20" data-id="element-251">
                    $19.990
                  </div>
                  <div className="p-4 bg-gold/5 text-gold font-bold" data-id="element-252">
                    $29.990
                  </div>
                </div>
                <div className="grid grid-cols-2 text-center border-b border-gold/20 text-sm md:text-base" data-id="element-253">
                  <div className="p-4 text-cream/70 border-r border-gold/20" data-id="element-254">
                    Sin Protocolo
                  </div>
                  <div className="p-4 bg-gold/5 text-gold" data-id="element-255">Con Protocolo</div>
                </div>
                <div className="grid grid-cols-2 text-center text-sm md:text-base" data-id="element-256">
                  <div className="p-4 text-cream/70 border-r border-gold/20" data-id="element-257">
                    Sin plan 21d
                  </div>
                  <div className="p-4 bg-gold/5 text-gold" data-id="element-258">Con plan 21d</div>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-259">
                <CTAButton variant="secondary" className="text-sm md:text-base px-6" data-id="element-260">
                  SISTEMA — $19.990
                </CTAButton>
                <CTAButton variant="primary" className="text-sm md:text-base px-6 shadow-gold" data-id="element-261">
                  ⭐ COMBO — $29.990
                </CTAButton>
              </div>
            </div>
          </FadeInSection>
        </div>
      </section>
    </>;
}